import type { CarrierPickupBooking } from "@/api/carrier";

type PickupBookingCustomer = NonNullable<
  CarrierPickupBooking["placerCustomer"]
>;

function customerName(customer: PickupBookingCustomer): string | null {
  return (
    [customer.firstName, customer.lastName].filter(Boolean).join(" ") || null
  );
}

export function formatPickupBookingAddress(
  booking: CarrierPickupBooking
): string {
  const address = booking.pickupAddress;
  if (!address) return "Address unavailable";

  const parts = [
    address.line1 ?? address.street,
    address.line2,
    address.city,
    address.province ?? address.state,
    address.postalCode,
    address.country,
  ].filter(Boolean);

  return parts.length > 0 ? parts.join(", ") : "Address unavailable";
}

export function formatPickupBookingCustomerName(
  booking: CarrierPickupBooking
): string {
  const customer = booking.placerCustomer;
  if (!customer) return "Customer unavailable";
  return customerName(customer) ?? `Customer #${customer.customerNumber}`;
}

export function formatPickupBookingCustomerSummary(
  booking: CarrierPickupBooking
): string {
  const customer = booking.placerCustomer;
  if (!customer) return "Customer unavailable";
  const name = customerName(customer);
  return name
    ? `${name} · Customer #${customer.customerNumber}`
    : `Customer #${customer.customerNumber}`;
}
